import $ from 'jquery'

$(document).ready(dhsv_vc_contact_details())

function dhsv_vc_contact_details() {
  // default selectors:
  var input_x_24 = $('#input_3_24')
  var input_x_25 = $('#input_3_25')
  var input_x_25_str = 'input_3_25'
  var input_x_26 = $('#input_3_26')

  // change selectors for website:
  if (window.location.href.indexOf('lek004.dev.360vier.net') > -1) {
    input_x_24 = $('#input_3_24')
    input_x_25 = $('#input_3_25')
    input_x_25_str = 'input_3_25'
    input_x_26 = $('#input_3_26')
  }
  if (window.location.href.indexOf('www.lekkerland.de') > -1) {
    input_x_24 = $('#input_11_24')
    input_x_25 = $('#input_11_25')
    input_x_25_str = 'input_11_25'
    input_x_26 = $('#input_11_26')
  }

  //If the user has selected customer / new customer and the zip code, he will receive the appropriate contact details of the deposited LC
  input_x_25.keyup(function () {
    //eslint-disable-next-line no-console
    //console.log('Handler for .keyup() called.')

    var plz = $(this).val() //get entered value

    if (plz.length == 5) {
      input_x_24.each(function () {
        //get contact type from dropdown
        var value = $(this).val().toString()

        var value_lowercase = value.toLowerCase()
        // eslint-disable-next-line no-console
        //console.log('Value: ' + value_lowercase)

        if (value_lowercase == 'kunde' || value_lowercase == 'neukunde') {
          // eslint-disable-next-line no-console
          //console.log('Kunder or Neukunde selected')

          // eslint-disable-next-line no-console
          //console.log(data_plz_value)

          $('.dhsv_vc_contact_details .contact_wrapper').each(function () {
            var data_plz_value = $(this).data('plz') //get the plz value from the element
            // eslint-disable-next-line no-console
            //console.log('PLZ Wert: ' + data_plz_value)

            if ($(this).hasClass('show')) {
              $(this).removeClass('show')
            }

            if (data_plz_value != '') {
              if (
                data_plz_value.indexOf(plz) != -1 &&
                $(this).hasClass(value_lowercase)
              ) {
                $(this).addClass('show')
                // eslint-disable-next-line no-console
                //console.log('value_lowercase: ' + value_lowercase)
                $(this).parent().find('h5').addClass('show')
              } else {
                //$(element).addClass('not-found')
              }
            }
          })
        }
      })
    } else {
      $('.dhsv_vc_contact_details .contact_wrapper').each(function () {
        $(this).removeClass('show')
        $(this).parent().find('h5').removeClass('show')
      })
    }
  })

  input_x_24.change(function () {
    var value = $(this).val().toString()

    var value_lowercase = value.toLowerCase()

    //find id that matches value
    var element = $('.' + value_lowercase)

    // eslint-disable-next-line no-console
    //console.log('value_lowercase ' + value_lowercase)

    var input_x_25_value = document.getElementById(input_x_25_str).value
    // eslint-disable-next-line no-console
    //console.log('input_x_25_value: ' + input_x_25_value)

    $('.dhsv_vc_contact_details .contact_wrapper').each(function () {
      if ($(this).hasClass('show')) {
        $(this).removeClass('show')
        $(this).parent().find('h5').removeClass('show')
      }
    })

    if (element) {
      // shoow headline
      $('.dhsv_vc_contact_details h5').addClass('show')

      $(element).each(function () {
        // check which element to show
        if (value_lowercase == 'kunde' && input_x_25_value == '') {
          if ($(this).hasClass('all-zips')) {
            $(this).addClass('show')
            // eslint-disable-next-line no-console
            //console.log('element: ' + element)
          }
        } else if (value_lowercase == 'kunde' && input_x_25_value != '') {
          $(this).addClass('show')
          // eslint-disable-next-line no-console
          //console.log('element 2: ' + this)
        } else if (
          value_lowercase != 'neukunde' &&
          value_lowercase != 'kunde'
        ) {
          $(this).addClass('show')
          // eslint-disable-next-line no-console
          //console.log('element 3: ' + this)
        }
      })
    } else {
      //
    }

    /*
      Dropdown Options (6):
      Kunde
      Interessent / Neukunde
      Lieferant (X=> Öffnet nur neues Dropdown)
      Export
      Presse
      Karriere
   */
  })

  input_x_26.change(function () {
    var value = $(this).val().toString()

    var value_lowercase = value.toLowerCase()

    //find id that matches value
    var element = $('.' + value_lowercase)

    // eslint-disable-next-line no-console
    //console.log('value_lowercase ' + value_lowercase)

    $('.dhsv_vc_contact_details .contact_wrapper').each(function () {
      if ($(this).hasClass('show')) {
        $(this).removeClass('show')
      }
    })

    if (element) {
      if (value_lowercase != 'kunde') {
        if (value_lowercase != 'neukunde') {
          $(element).addClass('show')
        }
      }
    } else {
      //
    }

    /*
      Dropdown Options:
      lieferant-international : Lieferant International
      lieferant-foodservice : Lieferant Foodservice
      lieferant-getraenke : Lieferant Getränke
      lieferant-non-food : Lieferant Non-Food
      lieferant-food-gebaeck-snacks-fruchtgummi : Lieferant Food: Gebäck, Snacks, Fruchtgummi
      lieferant-schokolade-kaugummi-bonbon-kinderartikel : Lieferant Schokolade, Kaugummi, Bonbon, Kinderartikel
      lieferant-e-va : Lieferant Electronic Value
      lieferant-tabak : Lieferant Tabak
   */
  })
}
